import React, { useEffect, useState } from 'react';
import { ObjectArray } from '../Page';
import { ButtonSquare } from '../../../components/design/buttons/Button';
import { BiCheck, BiChevronLeft, BiChevronRight, BiLeftArrow, BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
import Card from '../../../components/design/cards/card';
import { getProviders } from '../../../services/providers.service';
import { getNumbers,reserveNumber } from '../../../services/sim.service';
import { trackNumberReserved } from '../../../tools/tracking';
import { RiArrowLeftLine, RiArrowRightLine, RiSkipLeftLine, RiSkipRightLine } from 'react-icons/ri';
import { Modal } from 'react-bootstrap';
import { toast } from "react-toastify";
import { ShimmerTitle } from "react-shimmer-effects";
import './NumberCostumOrListOrTransfer.css';


const NumberCostumOrListOrTransfer: React.FC<ObjectArray> = ({ onOptionSelect, t , i18n, objs}) => {
    const [phoneError, setPhoneError] = useState<string>();
    const [number, setNumber] = useState<string>();
    const [providerId, setProviderId] = useState<number>();
    const [providers,  setProviders] = useState<any[]>([]);
    // Port-in is the landing tab when the customer arrived via "bring your
    // number", but only for a plan that actually accepts MNP — otherwise the
    // switch is hidden and they would be stuck on a tab they cannot leave.
    // Seeded here rather than in an effect so the heading doesn't flash the
    // other title on the first paint.
    const [type, setType] = useState<string>(
        objs?.plan?.acceptMnp && objs?.bringNumber ? "transfer" : "new"
    );
    const [errorNumber, setErrorNumber] = useState<string>();
    const [selectedCode, setSelectedCode] = useState<string>("966");
    const [showProviderModal, setShowProviderModal] = useState<boolean>(false);
    const [providerIdError, setProviderIdError] = useState<string>();
    const [provider, setProvider] = useState<any>();
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [filteredProviders, setFilteredProviders] = useState<any[]>([]);
    const fetchProviders = async () => {
        const response = await getProviders(i18n.language);
        const temp = response.returnData[7];
        response.returnData[7] = response.returnData[2];
        response.returnData[2] = temp;
        setProviders(response.returnData.slice(0, 10));
        setFilteredProviders(response.returnData.slice(0, 10));
    }

    React.useEffect(() => {
        fetchProviders();
    }, [i18n.language]);

    const onClick = async (number:string) =>
    {
        if (!number) {
            setPhoneError(t("local_sim.number_change_provider.phone_required"));
            return;
        }

        //show notification
        toast.info(t("local_sim.number_change_provider.phone_reserving"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        // reserveNumber
        const reserveNumberResponse = await reserveNumber({"identifier": number, plan_id: objs.plan_id}, objs.providerId);
        if (reserveNumberResponse.apiStatusCode !== 200) {
            setPhoneError(t("local_sim.number_change_provider.phone_error"));
            return;
        }
        setPhoneError('');

        let obj;
        
        if (type === "transfer") {
            if (!providerId) {
                setPhoneError(t("local_sim.number_change_provider.provider_required"));
                return;
            }
            obj = {
                "phone": number,
                "providerId": providerId
            }
        } else {
            obj = {
                "phone": number,
                "reserveNumber": reserveNumberResponse.returnData.reservationId
            }
        }
        

        trackNumberReserved(type === "transfer" ? "port_in" : "new");
        onOptionSelect(obj);
    }

    const onClick2 = () => {
        let hasError = false;
        //check the provider id
        if (!provider) {
            setProviderIdError(t("local_sim.number.transfer.provider_required"));
            hasError = true;
        }

        if (!number) {
            setErrorNumber(t("local_sim.identity_check.errors.required"));
            hasError = true;
        } else if (!/^(0\d{9}|5\d{8})$/.test(number)) {
            setErrorNumber(t("local_sim.identity_check.errors.invalid_phone"));
            hasError = true;
        } else {
            setErrorNumber('');
        }
        

        if (hasError) {
            return;
        }

        let obj = {
                "mnpNumber": number,
                "mnpOperator": (provider.id).toString(),
                "numberOrderType": 1
        }
        trackNumberReserved("port_in");
        onOptionSelect(obj);
    }

    useEffect(() => {
        // Fetch providers only when transfer mode is active.
        if (type === "transfer") {
            fetchProviders();
        }
    }, [type, i18n.language])

    // `bringNumber` is the flow-wide port-in flag — the wizard heading, the
    // provider filter and the checkout branch in Check all read it — so the
    // switch reports the active tab back without advancing to the next step.
    useEffect(() => {
        onOptionSelect({ bringNumber: type === "transfer" }, false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    useEffect(() => {
        let filtered = [...providers];
        
        // Filter out current provider if in transfer mode
        if (objs.bringNumber && objs.providerId) {
            filtered = filtered.filter(provider => provider.id !== objs.providerId);
        }
        
        // Apply search filter
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(provider => 
                provider.name.toLowerCase().includes(query)
            );
        }
        
        setFilteredProviders(filtered);
    }, [searchQuery, providers, objs.bringNumber, objs.providerId]);

    return (
        <div>
            {objs?.plan?.acceptMnp && (
                <div className="number-mode-switch mb-4" role="tablist" aria-label="Number mode switch">
                    <button
                        type="button"
                        className={`number-mode-switch__tab ${type === "new" ? "is-active" : ""}`}
                        onClick={() => setType("new")}
                        role="tab"
                        aria-selected={type === "new"}
                    >
                        {t("local_sim.number.new.title")}
                    </button>
                    <button
                        type="button"
                        className={`number-mode-switch__tab ${type === "transfer" ? "is-active" : ""}`}
                        onClick={() => setType("transfer")}
                        role="tab"
                        aria-selected={type === "transfer"}
                    >
                        {t("local_sim.number.transfer.title")}
                    </button>
                </div>
            )}

            {type === "new" ?
                <div>
                    <ListNumbers onSelect={(number: string) => 
                    {   
                    

                        onClick(number);
                    } } t={t} i18n={i18n} objs={objs}   />
                </div>
            :
                    <>
                        {/* <div className="form-group">
                            <label htmlFor="">{t("local_sim.number_change_provider.phone_number")}</label>
                            <input className={"form-control" + (phoneError ? " is-invalid" : "")}
                                />
                            {
                                phoneError && <p className="text-danger">{phoneError}</p>
                            }
                        </div> */}
                        {/* <div className="form-group">
                            <label htmlFor="">{t("local_sim.number_change_provider.provider")}</label>
                            <select className="form-control" value={providerId} onChange={(e) => setProviderId(Number(e.target.value))}>
                                <option value="">{t("local_sim.number_change_provider.select_provider")}</option>
                                {providers.map((provider) => (
                                    <option key={provider.id} value={provider.id}>
                                        {provider.name}
                                    </option>
                                ))}
                            </select>
                            {
                                providerId && <p className="text-danger">{providerId}</p>
                            }
                        </div> */}
                        <div className="form-group" onClick={() => setShowProviderModal(true)} style={{cursor: 'pointer'}}>
                            <label htmlFor="">{t("local_sim.number_change_provider.provider")}</label>
                            <div className='input_bg d-flex gap-3 align-items-center p-4 mt-2' style={{ padding: "10px" }}>
                                <div >
                                    {provider ? (
                                        <div className="d-flex align-items-center gap-3">
                                            <img
                                                src={provider.imagePathSmall}
                                                alt={provider.name}
                                                style={{ width: "30px", marginRight: "10px" }}
                                            />
                                            <span>{provider.name}</span>
                                        </div>
                                    ) : (
                                        <span>{t("local_sim.number_change_provider.select_provider")}</span>
                                    )}
                                </div>
                            </div>
                            {providerIdError && <p className="text-danger">{providerIdError}</p>}
                        </div>
                        <div className="form-group mt-4">
                            <label htmlFor="">{t("local_sim.identity_check.phone")}</label>
                            <div className="d-flex gap-3 align-items-center input_bg mt-3 " dir='rtl'>
                                <input
                                    className={`form-control form-control-lg${errorNumber ? " is-invalid" : ""}`}
                                    style={{ fontSize: '1.25rem',  border:0}}
                                    value={number}
                                    onChange={(e) => setNumber(e.target.value)}
                                />
                                <div className="country-code d-flex align-items-center px-3" style={{height: "83px"}}>
                                    <div className="country-flag"><img src="https://flagcdn.com/sa.svg" alt="flag"/></div>
                                    <div className="country-code-text">+{selectedCode}</div>
                                </div>

                                {/* <CountryCodeSelector style={{ height:83}} selectedCode={selectedCode} onCodeChange={setSelectedCode} /> */}
                            </div>
                            {errorNumber && <p className="text-danger mt-3">{errorNumber}</p>}
                        </div>
                        <div className='mt-4'>
                          
                            <ButtonSquare onClick={() => onClick2()}  inner={
                                        <div className='mx-5'>{t("local_sim.number_change_provider.button")}</div>
                                    }
                                    color="primary px-5"
                                    // isfullWidth={true}
                                    isrounded={true}/>
                                </div>
                        <Modal show={showProviderModal} onHide={() => setShowProviderModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("local_sim.number_change_provider.provider")}</Modal.Title>
                            </Modal.Header>
                          
                            <Modal.Body style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder={t("local_sim.number_change_provider.search_placeholder")}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {filteredProviders.map((provider) => (
                                <div
                                    key={provider.id}
                                    className="country-option d-flex gap-3 p-3 align-items-center"
                                    onClick={() => {
                                        setProvider(provider);
                                        setShowProviderModal(false);
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src={provider.imagePathSmall}
                                        alt={provider.name}
                                        style={{ width: "30px" }}
                                    />
                                    <span>{provider.name}</span>
                                    {provider.id === providerId && <span className="ml-2">(Selected)</span>}
                                </div>
                            ))}
                        </Modal.Body>
                        </Modal>
                       
                    </>
            }
        </div>
    );
};

const ListNumbers = ({onSelect, t, i18n, objs}: any) => {
    
    const onClick = (number: string) => () => {
        
        onSelect(number);
    }

    const number_type = ["All numbers", "Special"];

    const [numbers, setNumbers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        setIsLoading(true);
        // Keyed on the plan/provider the list actually depends on — `objs` gets a
        // new identity on every answer (the mode switch included) and would
        // re-fetch the list each time.
        getNumbers(null, objs.plan_id, objs.providerId).then((res: any) => {
            setNumbers(res.returnData);
            setIsLoading(false);
        }).catch((e: any) => {
            setIsLoading(false);
            setNumbers([]);

            console.log(e);
        });
    }, [objs.plan_id, objs.providerId]);

    const [currentNumber, setCurrentNumber] = useState<any>();

    // Generate shimmer cards for loading state
    const shimmerCards = Array.from({ length: 10 }, (_, index) => (
        <div key={`shimmer-${index}`} className='input_bg p-4' style={{cursor: "pointer"}}>
            <div className='col m-0'>
                <ShimmerTitle line={1} gap={10} variant="primary" />
            </div>
            <div className='col m-0 d-flex justify-content-end align-items-center'>
                <div style={{width: "32px"}}>
                    <ShimmerTitle line={1} gap={10} variant="primary" />
                </div>
            </div>
        </div>
    ));

    return (
        <div>
            <div className="mt-4 d-flex flex-column gap-3" >
                {isLoading ? (
                    shimmerCards
                ) : (
                    numbers.map((numberObj, index) => (
                        <div className='input_bg p-4 ' key={index} onClick={onClick(numberObj.number)} style={{cursor: "pointer"}}>
                                <div className='col m-0 bold'>{numberObj.number}</div>
                                <div className='col m-0 d-flex justify-content-end align-items-center gap-2'>
                                    {numberObj.vanity?.price ? (
                                        <span className='c-primary' style={{ fontWeight: 600 }}>
                                            {Number(numberObj.vanity.price).toFixed(2)} {t('global.sar')}
                                        </span>
                                    ) : null}
                                    {i18n.language === "ar" ? <BiChevronLeft color="rgb(0, 0, 0)" size={32}/> : <BiChevronRight color="rgb(0, 0, 0)" size={32}/>}
                                </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}







export default NumberCostumOrListOrTransfer;
 